import React, { useRef, useEffect } from "react";
// import { useInViewport } from "react-in-viewport";
import useResizeObserver from "../utils/useResizeObserver";
import "../style/CoverImg.scss";

const CoverImg = (prop) => {
  const { imgurl, imgurl_m, thisClass, text, width, height } = prop;

  // const imgRef = useRef(null);
  // const textRef = useRef(null);
  // const { width, height } = useResizeObserver(imgRef);

  // useEffect(() => {
  //   if (width < 800) {
  //   }
  // }, [width, height]);

  return (
    <div className={"cover-img-block"}>
      <div
        // ref={imgRef}
        className={thisClass}
        style={{
          backgroundImage:
            width > height
              ? `url(${process.env.PUBLIC_URL}/${imgurl})`
              : `url(${process.env.PUBLIC_URL}/${imgurl_m})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>

      <div
        // ref={textRef}
        className="text-block"
        dangerouslySetInnerHTML={{ __html: text }}
      ></div>
    </div>
  );
};

export default CoverImg;
